import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.element.addEventListener("click", this.prepend.bind(this));
  }

  disconnect() {
    this.element.removeEventListener("click", this.prepend.bind(this));
  }

  prepend() {
    const target = document.querySelector(this.element.dataset.inputPrependTarget)
    const value = this.element.dataset.inputPrependValue
    if (target && value) {
      target.value = value + target.value
    }
  }
}
